/*
 **	SFC Calibration (c) 2026 Silver Falls Capital. All Rights Reserved
 **
 **	This code is unlicensed and may not be copied, used, modified,
 **	compiled, run, or distributed in any form without the explicit
 **	written permission of Silver Falls Capital.
 **
 **/

import type { Configuration } from '@azure/msal-browser'
import Config from '../components/common/Config'

/**
 * MSAL configuration. Values are parameterised from build-time env vars rather
 * than hard-coded, following the sfc-notes / sfc-pager pattern.
 *
 * This is a public client: auth code flow with PKCE, no client secret and no
 * certificate. The SFC tenant disallows client secrets on confidential apps,
 * but a SPA is not one — it holds no credential at all.
 */
export const msalConfig: Configuration = {
	auth: {
		clientId: Config.AZURE_CLIENT_ID,
		authority: `https://login.microsoftonline.com/${Config.AZURE_TENANT_ID}`,
		redirectUri: typeof window !== 'undefined' ? window.location.origin : '/',
		postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '/',
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false,
	},
}

/**
 * The calibration Worker accepts tokens issued for its own API scope, which it
 * verifies locally against the tenant JWKS. A Graph-audience token (User.Read)
 * would force a round-trip to Graph on every request instead.
 */
export const loginRequest = {
	scopes: [`api://${Config.AZURE_CLIENT_ID}/access_as_user`],
}
